import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { BackLink } from '@aaimplatform/ui';
import type { BackLinkComponentProps } from '@aaimplatform/ui';

/** Adapts react-router's Link (which takes `to`) to BackLink's `href` contract. */
function RouterLinkAdapter({ href, className, children }: BackLinkComponentProps) {
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}

/**
 * The kit's BackLink routed through the SPA router, so "Back to X" on every
 * platform-admin detail page is one primitive, one color and a client-side
 * navigation. Tenant Detail rendered a red ghost Button and Pledge Detail a
 * gray raw button for the same affordance.
 */
export function RouterBackLink({
  to,
  children,
  className = 'mb-6',
}: {
  to: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <BackLink href={to} LinkComponent={RouterLinkAdapter} className={className}>
      {children}
    </BackLink>
  );
}
